// extracted by mini-css-extract-plugin
export default {"skeleton":"SkeletonPulse_skeleton__RQH0H","ssc-loading":"SkeletonPulse_ssc-loading__oxsh0","sscLoading":"SkeletonPulse_ssc-loading__oxsh0"};